import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconAttachment: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ?? 20}
      height={height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9165 9.08334L8.44595 15.5539C7.09193 16.9079 4.89621 16.9079 3.5422 15.5539C2.18818 14.1999 2.18818 12.0042 3.5422 10.6502L10.6012 3.59116C11.5039 2.68848 12.9675 2.68848 13.8701 3.59116C14.7728 4.49384 14.7728 5.95743 13.8701 6.86011L6.80535 13.9249C6.35401 14.3762 5.62221 14.3762 5.17088 13.9249C4.71954 13.4736 4.71954 12.7418 5.17088 12.2904L11.642 5.81934"
        stroke={color ?? "#475569"}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
